import ReactDOM from "react-dom/client";
import React from "react";
import { ConfiguratorWrapper } from "./components/configurator/Configurator";
import { Font } from "@react-pdf/renderer";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

const domContainer = <HTMLElement>document.querySelector("#Configurator");
Font.register({ family: "biotif", src: domContainer.dataset.biotifBold });
Font.register({ family: "Euclid", src: domContainer.dataset.euclidMedium });

const root = ReactDOM.createRoot(domContainer);
root.render(
    React.createElement(ConfiguratorWrapper, {
        token: domContainer.dataset.token,
        url: domContainer.dataset.url,
        csrf: domContainer.dataset.csrf,
        phone: domContainer.dataset.phone,
        email: domContainer.dataset.email,
    })
);
